
export const CREATE_GUEST_NEW_LANDING_USAGE_REQUEST = 'CREATE_GUEST_NEW_LANDING_USAGE_REQUEST'
export const CREATE_GUEST_REG_USAGE_REQUEST = 'CREATE_GUEST_REG_USAGE_REQUEST'

export const CREATE_GUEST_UNSUBSCRIBE_USAGE_REQUEST = 'CREATE_GUEST_UNSUBSCRIBE_USAGE_REQUEST'
export const CREATE_GUEST_UNSUBSCRIBE_SURVEY_USAGE_REQUEST = 'CREATE_GUEST_UNSUBSCRIBE_SURVEY_USAGE_REQUEST'

export const createGuestNewLandingUsage = ( email, campaignId ) => ({
	type: CREATE_GUEST_NEW_LANDING_USAGE_REQUEST,
	payload: { email, campaignId }
})

export const createGuestUnsubscribeUsage = ( email, campaignId ) => ({
	type: CREATE_GUEST_UNSUBSCRIBE_USAGE_REQUEST,
	payload: { email, campaignId }
})

export const createGuestUnsubscribeSurveyUsage = ( email, campaignId, option ) => ({
	type: CREATE_GUEST_UNSUBSCRIBE_SURVEY_USAGE_REQUEST,
	payload: { email, campaignId, option }
})

export const createGuestRegUsage = ( email, campaignId ) => ({
	type: CREATE_GUEST_REG_USAGE_REQUEST,
	payload: { email, campaignId }
})

const initialState = {
}

export const newLandingReducer = ( state = initialState, { type, payload }) => {
	switch(type){
		default:
			return state
	}
}
